const msgIdToTargetMap = new Map();

export function generateMsgId() {
  return 'msg_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
}

export function setMsgTarget(msgId, target) {
  console.log(msgId);
  console.log(target);
  msgIdToTargetMap.set(msgId, target);
}

export function getMsgTarget(msgId) {
  console.log(msgId);
  console.log(msgIdToTargetMap.get(msgId));
  return msgIdToTargetMap.get(msgId);
}

export function deleteMsgTarget(msgId) {
  msgIdToTargetMap.delete(msgId);
}
